import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../../utils/validators/string';
export const defaultCdnConfig = {
    vista: {
        url: undefined
    }
};
const vistaProviderConfigurationValidator = Validator.object({
    url: nonEmptyStringValidator,
    mediaApiToken: Validator.optional(nonEmptyStringValidator)
});
const moviexchangeProviderConfigurationValidator = Validator.object({
    url: nonEmptyStringValidator
});
export const cdnConfigValidator = Validator.object({
    vista: vistaProviderConfigurationValidator,
    moviexchange: Validator.optional(moviexchangeProviderConfigurationValidator)
});
